export default "__VITE_ASSET__XolPnQmz__"